import React, { Component } from 'react';

import {
  CitySelect,
  HotelSort,
  DistanceSelector,
  PriceSelector,
  GuestsSelector,
  ExperienceSelector,
  ProductSelector,
  DateSelector
} from '../index';

import {
  ParamsLine,
  ParamsContainer,
  OptionsList,
  OptionsItem,
  ParamsOption,
  CheckboxList,
} from './styles';

class HotelParamsLine extends Component {
  static ParamsOption = ParamsOption;

  static CheckboxList = CheckboxList;

  state = {
    currentDropdown: null,
  };

  handleDropdownClick = evt => {
    const { target } = evt;
    const dropdownName = target.name;

    this.setState(prevState => ({
      currentDropdown: prevState.currentDropdown === dropdownName ? null : dropdownName,
    }));
  };

  handleCloseDropdown = () => {
    this.setState({
      currentDropdown: null,
    });
  };

  render() {
    const { currentDropdown } = this.state;
    return (
      <ParamsLine>
        <ParamsContainer>
          <OptionsList>
            <OptionsItem>
              <CitySelect compact shouldFormQueryParams />
            </OptionsItem>
            <OptionsItem>
              <DateSelector currentDropdown={currentDropdown} handleDropdownClick={this.handleDropdownClick} handleCloseDropdown={this.handleCloseDropdown} />
            </OptionsItem>
            <OptionsItem>
              <GuestsSelector currentDropdown={currentDropdown} handleDropdownClick={this.handleDropdownClick} handleCloseDropdown={this.handleCloseDropdown} />
            </OptionsItem>
            <OptionsItem>
              <ProductSelector currentDropdown={currentDropdown} handleDropdownClick={this.handleDropdownClick} handleCloseDropdown={this.handleCloseDropdown} />
            </OptionsItem>
            <OptionsItem>
              <ExperienceSelector currentDropdown={currentDropdown} handleDropdownClick={this.handleDropdownClick} handleCloseDropdown={this.handleCloseDropdown} />
            </OptionsItem>
            <OptionsItem>
              <PriceSelector currentDropdown={currentDropdown} handleDropdownClick={this.handleDropdownClick} handleCloseDropdown={this.handleCloseDropdown} />
            </OptionsItem>
            <OptionsItem>
              <DistanceSelector currentDropdown={currentDropdown} handleDropdownClick={this.handleDropdownClick} handleCloseDropdown={this.handleCloseDropdown} />
            </OptionsItem>
          </OptionsList>
          <HotelSort currentDropdown={currentDropdown} handleDropdownClick={this.handleDropdownClick} handleCloseDropdown={this.handleCloseDropdown} />
        </ParamsContainer>
      </ParamsLine>
    );
  }
}

export default HotelParamsLine;
